export const SET_LOCATION = 'SET_LOCATION'
export const SET_DEVICES = 'SET_DEVICES'
export const SESSION_DEVICES = 'SESSION_DEVICES'



// WEBPACK FOOTER //
// ./src/store/modules/location/types.js